import { z } from 'zod';

import { requiredString } from '@/shared/utils/validation';

export const dateTimeFormatInputSchema = z.object({
  dateFormat: requiredString(),
  timeFormat: requiredString(),
});
